import { GenericSourceConfigHelper } from '../../../source-config-by-type/GenericSource/configHelper';
import { JobMode } from '../../../interfaces/job-mode';
import { SOURCE_TYPES } from '../../../interfaces/source-type';
import { SOURCE_TYPE_CONFIG_HELPERS } from '../../../constants/sourceTypeConfigHelperRegistry';
import { SourceTypeConfigHelper, SourceTypeConfigHelperConstructor } from './config-helper';


export class SourceConfigHelperService {
  private _configHelpers: { [key: string]: SourceTypeConfigHelper } = {};

  getConfigHelper(sourceTypeIdentifier: string, jobMode?: JobMode): SourceTypeConfigHelper {
    const existingRef = this._configHelpers[sourceTypeIdentifier];

    if (existingRef) {
      return existingRef;
    }

    const sourceTypeMetaData = SOURCE_TYPES[sourceTypeIdentifier];
    const configHelperClass: SourceTypeConfigHelperConstructor =
      sourceTypeMetaData.genericReactComponent
      ? GenericSourceConfigHelper
      : SOURCE_TYPE_CONFIG_HELPERS[sourceTypeIdentifier];

    let newRef: SourceTypeConfigHelper = new configHelperClass(sourceTypeIdentifier, jobMode);

    this._configHelpers[sourceTypeIdentifier] = newRef;

    return newRef;
  }
}
